<template>
<div class="body1">
  <div style="font-size: 35px;font-weight: bold;text-align: center">修改发布信息</div>
 <el-form  :model="form1" :rules="rules"  ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="标题" prop="title">
    <el-input v-model="form1.title" ></el-input>
  </el-form-item>
   <el-form-item label="来源" prop="source">
    <el-input v-model="form1.source" ></el-input>
  </el-form-item>
   <el-form-item label="关键字" prop="summary">
     <el-input v-model="form1.summary"></el-input>
   </el-form-item>
   <el-form-item label="内容" prop="content">
    <el-card style="height: 500px;">
      <quill-editor v-model="form1.content" ref="myQuillEditor" style="height: 500px;" :options="editorOption">
      </quill-editor>
    </el-card>
  </el-form-item>
   <el-form-item label="创建时间" >
    <el-col :span="11">
      <el-form-item prop="updateDate">
        <el-date-picker v-model="form1.updateDate" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width: 200px;margin-left: -140px;">
    </el-date-picker>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="checkForm('form1')"  @keyup.enter.native="checkForm('form1')">保存</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl, dataPost } from '@/api/index'
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  name: 'admininformationupdate',
  components: {quillEditor},
  data () {
    var Title = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var Source = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入来源'))
      } else {
        callback()
      }
    }
    var Content = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入内容'))
      } else {
        callback()
      }
    }
    var UpdateDate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择时间'))
      } else {
        callback()
      }
    }
    var Summary = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入简介'))
      } else {
        callback()
      }
    }
    return {
      editorOption: {
        placeholder: '请输入',
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'clean', 'blockquote', 'code-block'], // toggled buttons
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }]
          ]
        }

      },
      form1: {
        title: '',
        source: '',
        content: '',
        createTime: '',
        summary: '',
        state: '',
        updateDate: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { validator: Title, trigger: 'blur' }
        ],
        source: [
          { required: true, message: '请输入来源', trigger: 'blur' },
          { validator: Source, trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { validator: Content, trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: '请选择时间', trigger: 'blur' },
          { validator: UpdateDate, trigger: 'blur' }
        ],
        summary: [
          { required: true, message: '请输入简介', trigger: 'blur' },
          { validator: Summary, trigger: 'blur' }
        ]
      },
      value: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }

    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/admini/news/find?id=' + that.$route.query.pid).then(function (response) {
      that.checkSignin(response.data.result)
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      params.append('id', this.form1.id)
      params.append('title', this.form1.title)
      params.append('source', this.form1.source)
      params.append('content', this.form1.content)
      params.append('createTime', this.form1.createTime)
      params.append('updateDate', this.form1.updateDate)
      params.append('summary', this.form1.summary)
      if (that.form1.title === '') { alert('请输入标题') } else {
        dataPost(rootPathssb.rootPath + '/admini/news/update', params).then(function (response) {
          that.checkSignin(response.data.result)
          if (response.data.result === 1) {
            alert('保存成功')
            that.$router.push({path: '/admininformation'})
            console.log('cg')
          };

          console.log(response.data)
        }).catch(function (error) {
          console.log(error); console.log(2222222222); alert('失败')
        })
      }
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }

}
</script>

<style scoped>
  .dateleft input{

    text-indent: 2em !important;
  }
.body1{
  width:1000px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/admininformationupdate.vue